import { RootState } from '../rootReducer'
import { createSelector } from 'reselect'

const pagesSelector = (state: RootState) => state.pages

export const privacySelector = createSelector(pagesSelector, (state) => state.privacy)

export const termsSelector = createSelector(pagesSelector, (state) => state.terms)
